export default __webpack_public_path__ + "static/media/active-clock-icon-versa.cd3f775f82b5abe55a48887168c7429d.svg";